import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { bundle } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder, validateOptions } from '../http';
export var fetchBridgeModels = function fetchBridgeModels() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.get("".concat(bundle.apiLocation(), "/models"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModels: response.data.models
    };
  })["catch"](handleErrors);
};
export var fetchBridgeModel = function fetchBridgeModel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchBridgeModel', ['modelName'], options);
  return axios.get("".concat(bundle.apiLocation(), "/models/").concat(options.modelName), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModel: response.data.model
    };
  })["catch"](handleErrors);
};
var TEST_METHODS = ['retrieve', 'search', 'count'];
export var testBridgeModel = function testBridgeModel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('testBridgeModel', ['modelName', 'qualificationName', 'method'], options);
  var modelName = options.modelName,
      qualificationName = options.qualificationName,
      _options$attributes = options.attributes,
      attributes = _options$attributes === void 0 ? [] : _options$attributes;
  var method = TEST_METHODS.includes(options.method) ? options.method : 'retrieve';
  var parameters = options.parameters.reduce(function (params, parameter) {
    params["parameters[".concat(parameter.name, "]")] = parameter.value;
    return params;
  }, {});
  return axios.post("".concat(bundle.spaceLocation(), "/app/models/").concat(modelName, "/qualifications/").concat(qualificationName, "/").concat(method), null, {
    params: _objectSpread(_objectSpread({}, paramBuilder(options)), {}, {
      attributes: attributes.join(',')
    }, parameters),
    headers: headerBuilder(options)
  })["catch"](handleErrors);
};
export var createBridgeModel = function createBridgeModel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createBridgeModel', ['bridgeModel'], options);
  return axios.post("".concat(bundle.apiLocation(), "/models"), options.bridgeModel, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModel: response.data.model
    };
  })["catch"](handleErrors);
};
export var updateBridgeModel = function updateBridgeModel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateBridgeModel', ['modelName', 'bridgeModel'], options);
  return axios.put("".concat(bundle.apiLocation(), "/models/").concat(options.modelName), options.bridgeModel, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModel: response.data.model
    };
  })["catch"](handleErrors);
};
export var deleteBridgeModel = function deleteBridgeModel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteBridgeModel', ['modelName'], options);
  return axios["delete"]("".concat(bundle.apiLocation(), "/models/").concat(options.modelName), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      bridgeModel: response.data.model
    };
  })["catch"](handleErrors);
};